<template>
  <transition name="el-fade-in-linear">
  <div v-show="transitionshow"> 
      
      <!----------------- clert group lists start（新增会员组别列表）------------------>
      <el-form :inline="true" class="backborder1 demo-form-inline" size="small">
          <el-form-item>
              <el-button type="primary" icon="el-icon-circle-plus-outline"  @click="creategroupaddDialog = true" v-if="actionauth.base_clerk_group_add=='true'">新增会员组别</el-button>
          </el-form-item>
      </el-form>
      
      <div class="backborder2" style="margin-top:10px">
          <el-table :data="grouplists" v-loading="groupLoading">
        	  <el-table-column prop="id" label="编号"  width="140"></el-table-column>
          	  <el-table-column prop="name" label="名称"></el-table-column>
          	  <el-table-column label="是否使用" width="150">
          		  <template slot-scope="status">
            		  <el-switch active-color="#ff4949" inactive-color="#cccccc" v-model="status.row.status" @change="changestatus(status.$index,status.row)"></el-switch>
          		  </template>
          	  </el-table-column>
          	  <el-table-column label="操作" width="150" v-if="actionauth.base_clerk_group_edit=='true' || actionauth.base_clerk_group_del=='true'">
          		  <template slot-scope="scope">
            		  <el-button type="primary" size="small" circle icon="el-icon-edit" @click="editgrouppercent(scope.row)" v-if="actionauth.base_clerk_group_edit=='true'"></el-button>
            		  <el-button type="danger" size="small" circle icon="el-icon-delete" @click="deletegrouppercent(scope.row)" v-if="actionauth.base_clerk_group_del=='true'"></el-button>
          		  </template>
          	  </el-table-column>
          </el-table>
          
          <div class="block">
	          <!--分页begin-->
	          <el-pagination
	            @size-change="pageSizegroup"
	            @current-change="pageCurrentgroup"
	            :current-page="group.p"
	            :page-sizes="[10, 20, 50]"
	            :page-size="group.rollpage"
	            layout="total, sizes, prev, pager, next, jumper"
	            :total="group_total_rows">
	          </el-pagination>
	          <!--分页end-->
          </div> 
	  </div>
      <!----------------- clert group lists end（新增会员组别列表）-------------------->
      
      <!----------------- add clert group start（新增会员组别列表）------------------>
      <el-dialog title="新增会员组别" :visible.sync="creategroupaddDialog" width="25%">
      	  <el-form ref="clerkrules" :model="clerkrules" :rules="addclerkrules" size="small" label-width="80px">
	          <el-col :span="23">
	              <el-form-item label="组别名称" prop="name">
	                  <el-input v-model="localgroup.name"></el-input>
	              </el-form-item>
	          </el-col>
          </el-form>
      	  <div slot="footer" class="dialog-footer">
              <el-button size="small" @click="creategroupaddDialog = false">取 消</el-button>
              <el-button size="small" type="primary" :loading="creategroupLoading"  @click="creategroupadd">保 存</el-button>
          </div>
      </el-dialog>
      <!----------------- add clert group end（新增会员组别列表）------------------>
      
      <!----------------- edit clert group start（新增会员组别列表）------------------>
      <el-dialog title="编辑会员组别" :visible.sync="creategroupeditDialog" width="25%">
      		<el-form ref="editclerkrules" :model="clerkrules" :rules="editclerkrules" size="small" label-width="80px">
	            <el-col :span="23">
	                <el-form-item label="组别名称" prop="name">
	                	<el-input v-model="localgroup.name"></el-input>
	                </el-form-item>
	            </el-col>
            </el-form>
      		<div slot="footer" class="dialog-footer">
            	<el-button size="small" @click="creategroupeditDialog = false">取 消</el-button>
            	<el-button size="small" type="primary" :loading="creategroupeditLoading"  @click="creategroupedit">保 存</el-button>
          	</div>
      </el-dialog>
      <!----------------- edit clert group end（新增会员组别列表）------------------>
 
  </div>
  </transition>
</template>

<script>

export default {
  data () {
    return {
      actionauth:'', //操作权限
      transitionshow:true,
      url:this.GLOBAL.domain+"Clerk/index",
      creategroupaddDialog:false,
      groupLoading: false,
      group_total_rows:0,
      group: {
      	url:this.GLOBAL.domain+"Clerk/index",
      	token:this.$cookies.get('token'),
      	act:'lists',
      	name:'',
      	id:'',
      },
      localgroup:[], //当前组
      creategroupeditDialog:false,
      creategroupDialog:false,
      grouplists:[],
      group_total_rows:0,
      addclerkrules: {
      	name: [
            { required: true, message: '请输入组别名称', trigger: 'blur' },
            { min: 2, max: 20, message: '长度在 2 到 20 个字符'}
        ],
      },
      creategroupLoading:false,
      creategroupeditLoading:false,
      
    }
  },
  mounted(){
      this.getactionauth();
      this.getclerkgrouplists(); //获取会员组别列表
      
  },
  methods:{  
  
  	/** 获取操作权限 **/
  	getactionauth() {
    	var data =this.$cookies.get('actionauth');
    	data=JSON.parse(data);
        this.actionauth=data;
    },
    
    /** 开启或关闭会员组 **/
    changestatus(index,obj) {
    	var resource = this.$resource(this.url);
        resource.save({act:'changestatus',token:this.$cookies.get('token'),id:obj.id,status:obj.status}).then((res) => {
            if(res.data.Result>0){
	            if(res.data.Result=='70001') this.$router.push('/login');
            }
        }).catch((res) => {
            this.$message.error(this.GLOBAL.errortext);
        });
    },
    
    /** 获取编辑组别信息 **/
    editgrouppercent(obj) {
    	this.localgroup=[{id:obj.id,name:obj.name}];
    	this.localgroup.id=obj.id;
    	this.localgroup.name=obj.name;
    	this.creategroupeditDialog=true;
    },
    
    /** 删除组别 **/
    deletegrouppercent(obj) {
    	this.$confirm('此操作将永久删除 ' + obj.name + ', 是否继续?', '提示', { type: 'warning' }).then(() => {
              var resource = this.$resource(this.url);
              resource.save({ act:'deletegroup',id: obj.id,token:this.$cookies.get('token')}).then((res) => {
                  if(res.data.Result>0){
                    if(res.data.Result=='70001') this.$router.push('/login');
                    this.$message.error(res.data.Message);
                  }else{
                    this.$message.success('成功删除了' + obj.name + '!');
                    this.getclerkgrouplists();
                  }
              }).catch((res) => {
                  this.$message.error(this.GLOBAL.errortext);
              });
        }).catch(() => {
        	
        });
    },
    
    /** 获取职员组别列表 **/
    getclerkgrouplists() {
    	this.creategroupDialog = true;
    	this.groupLoading=true;
    	this.group.act='getclerkgrouplists';
    	var resource = this.$resource(this.group.url);
    	resource.query(this.group).then((res) => {
            if(res.data.Result>0){
	            if(res.data.Result=='70001'){
	              this.$router.push('/login');
	              this.groupLoading=false;
	            }
            	this.$message.error(res.data.Message);
            	this.groupLoading=false;
            }else{
				this.grouplists = JSON.parse(Base64.decode(res.data.Data));
          		this.group_total_rows=parseInt(res.data.count);
          		this.groupLoading=false;
            }
        }).catch((res) => {
            this.$message.error(this.GLOBAL.errortext);
            this.groupLoading=false;
        });
    },
    
    pageSizegroup(val) {
        this.group.rollpage = val;
        this.getclerkgrouplists();
    },
    pageCurrentgroup(val) {
        this.group.p = val;
        this.getclerkgrouplists();
    },
    
    /** 新增职员组别 **/
    creategroupadd() {
		this.creategroupLoading=true;
		var resource = this.$resource(this.url);
		resource.save({act:'addClerkgroup',token:this.$cookies.get('token'),name:this.localgroup.name}).then((res) => {
			if(res.data.Result>0){
				if(res.data.Result=='70001') this.$router.push('/login');
			    this.creategroupLoading=false;
		        this.$message.error(res.data.Message);
		    }else{
		    	this.creategroupLoading=false;
		        this.creategroupaddDialog=false;
		        this.getclerkgrouplists();
		        this.$message.success('添加组别：' + this.localgroup.name + '成功!');
		    }
		}).catch((res) => {
		    this.creategroupLoading=false;
		    this.creategroupaddDialog=false;
		});
    },
    
    /** 保存编辑职员组别 **/
    creategroupedit() {
		this.creategroupeditLoading=true;
		var resource = this.$resource(this.url);
		resource.save({act:'editClerkgroup',token:this.$cookies.get('token'),id:this.localgroup.id,name:this.localgroup.name}).then((res) => {
		    if(res.data.Result>0){
				if(res.data.Result=='70001'){
			    	this.$router.push('/login');
			        this.creategroupeditLoading=false;
			        this.creategroupeditDialog=false;
				}
				this.creategroupeditLoading=false;
			    this.creategroupeditDialog=false;
		        this.$message.error(res.data.Message);
		    }else{
		    	this.creategroupeditLoading=false;
		        this.creategroupeditDialog=false;
		        this.getclerkgrouplists();
		        this.$message.success('修改组别名称：' + this.localgroup.name + '成功!');
		    }
		}).catch((res) => {
			this.creategroupeditLoading=false;
		    this.creategroupeditDialog=false;
		});
    },
    
    

  }
}
</script>
<style type="text/css">
.backborder1 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:1% 1% 0 1%}
.backborder2 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:0 1% 3% 1%}
</style>


// WEBPACK FOOTER //
// src/components/base/Clerkgroup.vue